// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__1+gxM","formItem":"styles_formItem__fUr5S","formFull":"styles_formFull__sQxsJ","InputNumber":"styles_InputNumber__PcOMy"};